import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource } from "kea-resource";
const controller = rpcController("Guia");
import { addOnInvalidateHandler, invalidateResource } from "kea-resource";

import { Documentacion } from "./documentacion";
import { EntregaOcurre } from "./entregaocurre";


export const Guia = cacheResource({
    /**
 * Obtiene una entidad
 * @param id Id de la entidad
 */
    Get: async (folio: string): Promise<models.GuiaDTO> => await controller("Get", { folio }),

    GetFromId: async (id: number): Promise<models.GuiaDTO> => await controller("GetFromId", { id }),

    /**Obtiene todas las entidades filtradas por la zona */
    Query: async (filtro: models.FiltroGuia): Promise<models.GuiaDTO[]> => await controller("Query", {}, filtro),
    QueryConsulta: async (filtro: models.FiltroGuia): Promise<models.GuiaConsulta[]> => await controller("QueryConsulta", {}, filtro),
    QueryLimit: async (filtro: models.FiltroGuia): Promise<models.GuiaDTO[]> => await controller("QueryLimit", {}, filtro),
    QueryGuiasZonaExtendida: async (): Promise<models.GuiaDTO[]> => await controller('QueryGuiasZonaExtendida', {}),

    GuiasFactura: async (idFactura: number): Promise<models.GuiaDTO[]> => await controller("GuiasFactura", { idFactura }),

    RecolectarGuia: async (IdGuia: number, IdManifiestoRad: number): 
    Promise<string> => 
    await controller("RecolectarGuia", { IdGuia, IdManifiestoRad }),

    RecolectarGuiaSinValidarFolio: async (IdGuia: number, IdManifiestoRad: string): 
    Promise<string> => 
    await controller("RecolectarGuiaSinValidarFolio", { IdGuia, IdManifiestoRad }),

    ValidarFolioRad: async (Folio: number): Promise<models.BitacoraRAD> => await controller("verificarRad", { Folio }),

    /**
       * Genera el reporte de guia
       * @param folio Folio de la guia
       */
    ReporteGuia: async (folio: string): Promise<string> => await controller("ReporteGuia", { folio }),

    /**
     * Genera el acuse de recibo de una guia. Pase el folio de la guia original, no el folio de la guia de acuse
     * @param folio Folio de la guia
     */
    ReporteAcuse: async (folio: string): Promise<string> => await controller("ReporteAcuse", { folio }),

    /**
     * Obtiene los contactos autorizados para la entrega de una guia
     */
    ObtenerContactosAutorizados: async (folios: string[]): Promise<models.ContactoCliente[]> => await controller("ObtenerContactosAutorizados", { folios }),

    /**Devuelve si existe una guia dado su folio */
    ExisteGuia: async (folio: string): Promise<boolean> => await controller('ExisteGuia', { folio }),

    /**Cancela una guía */
    CancelarGuia: async (folio: string): Promise<boolean> => await controller('CancelarGuia', { folio }),

    /**Marca una guía como no facturable */
    MarcarGuiaNoFacturable: async (folio: string): Promise<boolean> => await controller('MarcarGuiaNoFacturable', { folio }),

    /**Obtiene el reporte de conteo de guías */
    ReporteConteo: async (parametros: models.ConteoGuiasParams): Promise<string> => await controller('ReporteConteo', {}, parametros),

    QueryInicial :async (): Promise<models.GuiaConsulta[]> => await controller("QueryInicial", {}, {}),

    GetHistorialGuia: async (idGuia: number): Promise<models.StatusGuiaViewDTO[]> => await controller("GetHistorialGuia", {idGuia} ),
}, {
        Query: true,
        GetFromId: true,
        QueryGuiasZonaExtendida: true,
        ObtenerContactosAutorizados: true,
        ExisteGuia: true,
        GuiasFactura: true,
        QueryInicial:true,
        QueryConsulta:true,
        GetHistorialGuia:true
    }, {
        CancelarGuia: true
    });


addOnInvalidateHandler(Documentacion, () => invalidateResource(Guia));
addOnInvalidateHandler(EntregaOcurre, () => {
    invalidateResource(Guia);
});


// WEBPACK FOOTER //
// ./app/resources/items/guia.ts